@if (config.personalizationMode==='fromType') {
  <table>
    @if (config.firstName) {
      <tr>
        <td translate>clivqq8ex000108jqab7rgnp4</td>
        <td>{{config.firstName}}</td>
      </tr>
    }
    @if ((config ).secondName) {
      <tr>
        <td translate>clivqqhme000208jqd137b57d</td>
        <td>{{(config).secondName}}</td>
      </tr>
    }
    @if ((config ).date) {
      <tr>
        <td translate>clivqqozc000308jq8tz97jgu</td>
        <td>{{(config).date}}</td>
      </tr>
    }
    @if ((config ).connector) {
      <tr>
        <td translate>clivqqwr0000408jqbryng45c</td>
        <td>{{(config).connector}}</td>
      </tr>
    }
  </table>
} @else {
  <table>
    @for (field of (config).lines; track field; let i = $index) {
      <tr>
        <td><span translate>clivqr5m6000508jq37ze4pbr</span> {{i + 1}}</td>
        <td>{{field}}</td>
      </tr>
    }
  </table>
}
